export default __webpack_public_path__ + "2d5b66ce665b8aa303e4676c0b4f334e.jpg";